export default "__VITE_ASSET__CgKp0OVI__"